<template lang="html">
  <div class="merchant-container flex spaced column">
    <div class="top-img">
      <div class="overlay overblue"></div>
      <img src="../assets/images/merch/merchpage_main.png" alt="">
    </div>
    <div class="content-top text-white row">
      <div class="page-title--norm content-padded">
        As the world moves closer to a <br class="desktop-only">digital economy, Pesaflow powers <br class="desktop-only">
        settlements for merchants and <br class="desktop-only">keeps them ahead
      </div>
      <div class="flex wrap content-slim--desktop">
        <div class="content-padded content-mintext equal-width">
          From corporations to businesses, Pesaflow tracks all financial movements through virtual accounts,
          helping them operate and run in a modern and tech-forward way.
        </div>
        <div class="content-padded content-mintext equal-width">
          Whether it’s handling B2B payments, settlements to merchants or internal disbursements,
          Pesaflow offers a dynamic solutions for payments aggregation and processing.
        </div>
      </div>
    </div>
    <div class="dark-blue text-white row flex column wrap">
      <div class="content-padded content-maintext flex column equal-width">
        Pesaflow makes settlements as simple as they should be.
      </div>
      <div class="content-padded content-subtext work-text  equal-width">
        Merchants need to send and receive payments. In an ever evolving digital landscape, finding a singular,
        reliable solution to handle settlements can be daunting. Stop struggling with multiple payment service providers.
        Switch to a more powerful, all-in-one solution. Whether it’s making settlements, aggregating or facilitating payments,
        Pesaflow can be seamlessly into any merchant’s financial process.
      </div>
    </div>
    <div class="row content-spaced text-blue white">
      <div class="content-margin">
        <div class="content-maintext content-padded">
          Handy tools for merchants at all levels
        </div>
        <div class="wrap flex">
          <div class="flex third-width column">
            <div class="content-subtitle content-padded container top-rule">
              Faster Payments
            </div>
            <div class="content-subtext content-padded">
              Merchants can improve customer experience with Pesaflow by offering a quick and convenient way to make payments within
              minutes, using the payment method of their choice.
            </div>
          </div>
          <div class="flex third-width column">
            <div class="content-subtitle content-padded container top-rule">
              Expanded Reach
            </div>
            <div class="content-subtext content-padded">
              Pesaflow adds new payment methods based on market conditions and consumer adoption to keep merchants up-to-date.
            </div>
          </div>
          <div class="flex third-width column">
            <div class="content-subtitle content-padded container top-rule">
              Improved Cash Flow
            </div>
            <div class="content-subtext content-padded">
              Pesaflow reduces the unnecessary load of collection calls or waiting for checks.
              Pesaflow’s invoice payment gives customers an easy way to pay online and get businesses money faster.
            </div>
          </div>
          <div class="flex third-width column">
            <div class="content-subtitle content-padded container top-rule">
              Useful Insights
            </div>
            <div class="content-subtext content-padded">
              Through Pesaflow, merchants can access insights needed to effectively run their businesses with reports and analytics.
            </div>
          </div>
          <div class="flex third-width column">
            <div class="content-subtitle content-padded container top-rule">
              Advanced Reporting
            </div>
            <div class="content-subtext content-padded">
              Reporting for payments does not need to be complicated. Pesaflow makes it easy to track transactions to help merchants know
              what to expect and when to expect it. View settlements, payments or transaction summaries categorized by payment method.
            </div>
          </div>
          <div class="flex third-width column">
            <div class="content-subtitle content-padded container top-rule">
              Reduced Integration Costs
            </div>
            <div class="content-subtext content-padded">
              All a merchant ever needs is a single integration to one payments gateway to get connected to multiple payment channels.
            </div>
          </div>
          <div class="flex third-width column">
            <div class="content-subtitle content-padded container top-rule">
              Solid Data Security
            </div>
            <div class="content-subtext content-padded">
              Data security is of enormous importance to Pesaflow, with vital steps taken to safeguard customers’ information.
            </div>
          </div>
          <div class="flex third-width column">
            <div class="content-subtitle content-padded container top-rule">
              Easy On-boarding
            </div>
            <div class="content-subtext content-padded">
              Offering dynamic integration points, including APIs and hosted solutions, Pesaflow gets merchants up and running
              quickly with an easy to integrate solution that lets you start offering payments immediately.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="back-img">
        <div class="overlay dark-blue"></div>
        <img src="../assets/images/merch/merchpage_1.png" alt="">
      </div>
      <div class="row text-white container column">
        <div class="content-padded content-subtitle content-margin">
          Connecting the dots
        </div>
        <div class="content-padded content-maintext">
          With Pesaflow, merchants can <br class="desktop-only">understand spending patterns, <br class="desktop-only">
          increase control over spending,<br class="desktop-only">identify savings opportunities and <br class="desktop-only">
          facilitate approval processes.
        </div>
        <div class="content-padded content-mintext">
          Pesaflow provides merchants with <br class="desktop-only">tools to increase efficiency and <br class="desktop-only">tighten controls,
          helping track and <br class="desktop-only">manage expenses while also improving <br class="desktop-only">compliance and security.
        </div>
      </div>
    </div>
    <div class="row content-spaced text-blue content-margin flex column">
      <div class="flex wrap">
        <div class="content-subtitle content-padded desc-left flex">
          Powering business intelligence
        </div>
        <div class="flex wrap content-padded desc-right flex">
          <div class="right-padded content-mintext equal-width">
            Pesaflow’s advanced analytic tools transform data into actionable insight that can inform strategic and tactical business decisions.
          </div>
          <div class="right-padded content-mintext equal-width">
            Powered by machine learning, Pesaflow provides an intelligent financial system that can learn user trends and offer insights that improve efficiency.
          </div>
        </div>
      </div>
      <div class="flex wrap content-padded desc-bottom">
        <div class="content-padded content-timeline equal-width">
          <div class="content-subtitle content-padded">
            Convert data to information
          </div>
          <div class="content-padded content-mintext equal-width">
            Pesaflow generates data from all payment activities through all channels and presents it as easily accessible information.
          </div>
        </div>
        <div class="content-padded content-timeline equal-width">
          <div class="content-subtitle content-padded">
            Convert knowledge to intelligence
          </div>
          <div class="content-padded content-mintext equal-width">
            By using advanced analytic techniques, Pesaflow progressively analyses and synthesises data to reveal trends over time.
          </div>
        </div>
      </div>
    </div>
    <div class="row content-spaced text-blue light-blue">
      <div class="content-padded content-maintext">
        Originally a settlements engine built with governments in mind, Pesaflow’s powerful technology helps merchants do more.
      </div>
      <div class="flex wrap">
        <div class="flex third-width column">
          <div class="content-subtitle content-padded container top-rule">
            Payment <br class="desktop-only"/>Transparency
          </div>
          <div class="content-subtext content-padded">
            With visibility into settlements as they happen in realtime and automated reconciliations, Pesaflow creates clear trails and records.
          </div>
        </div>
        <div class="flex third-width column">
          <div class="content-subtitle content-padded container top-rule">
            Enhanced <br class="desktop-only"/>efficiency
          </div>
          <div class="content-subtext content-padded">
            By coupling payment details with the transaction, real-time payments help improve efficiency, customer engagement,
            data transparency and accuracy.
          </div>
        </div>
        <div class="flex third-width column">
          <div class="content-subtitle content-padded container top-rule">
            Customisation and integrations supported
          </div>
          <div class="content-subtext content-padded">
            In the absence of any system set up or with existing technology, Pesaflow’s custom payments collection engine can
            be configured and plugged in as a payment aggregator.
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="back-img">
        <div class="overlay dark-blue"></div>
        <img src="../assets/images/home/homepage_6.png" alt="">
      </div>
      <div class="row text-white container">
        <div class="top-spaced content-maintext content-padded content-slim">
          Your success and growth <br class="desktop-only"/>are our top priority.
        </div>
        <div class="content-subtext content-padded content-slim">
          Our teams are available to help, every <br class="desktop-only"/>step of the way.
        </div>
      </div>
    </div>
    <div class="container">
      <div class="back-img med-blue">
        <img src="../assets/images/home/homepage_7.png" alt="">
      </div>
      <div class="row content-margin flex wrap spaced container">
        <div class="content-padded content-maintext">
          Scale your business or <br class="desktop-only"/>organization by tapping into <br class="desktop-only"/>
          the same powerful tools <br class="desktop-only"/>trusted by governments.
        </div>
        <div class="content-padded vertical-center flex">
          <button type="button" name="button" class="dark-blue text-white talk-btn">Talk to us today</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint max-len: 0 */
export default {
  name: 'Merchant',
};
</script>

<style lang="css" scoped>
.content-top {
  min-height: 81vh;
}
@media only screen and (min-width: 1024px) {
  .content-top {
    min-height: 68vh;
  }
  .third-width {
    max-width: 25%;
  }
  .desc-left {
    flex: 1;
  }
  .desc-right {
    flex: 2.5;
  }
  .desc-bottom {
    width: 70%;
    align-self: flex-end;
  }
  .right-padded {
    padding-right: 30px;
  }
  .content-padded.top-rule:before {
    top: 5px;
  }
}
</style>
